import React from 'react';
import { ContactProfilePage } from './ContactProfilePage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { UUID } from '../../types/shared/UUID';
import { Button } from 'ui-toolkit/index';
import { IPresentationInternalContact } from '../../types/contacts/IInternalContact';
import { useToggle } from '../../utilities/hooks/useToggle';

interface IContactProfileContainerProps {
  userId: UUID;
  userContactData: IPresentationInternalContact;
}

export const ContactProfileContainer: React.FC<IContactProfileContainerProps> = ({ userId, userContactData }) => {
  const [showContactPage, toggleContactPage] = useToggle();

  if (!showContactPage) {
    return (
      <Button intent={'ghost'} onClick={toggleContactPage} key={userId}>
        <FontAwesomeIcon icon={faUser} />
      </Button>
    );
  }

  return (
    <ContactProfilePage key={userId} userContactData={userContactData} onClose={toggleContactPage} userId={userId} />
  );
};
